import type { TreeNode } from "../../file-tree-manager/types/tree-types"

const getStatusPriority = (node: TreeNode): number => {
  const status = node.status
  if (!status) return 99
  const order: Record<string, number> = {
    draft: 10,
    convert: 9,
    converting: 8,
    converted: 7,
    review: 6,
    request: 5,
    requested: 4,
    pending: 3,
    approve: 2,
    publishing: 1,
    published: 0,
  }
  return order[String(status)] ?? 99
}

export const sortTreeNodes = (nodes: TreeNode[]): TreeNode[] => {
  const sorted = [...nodes].sort((a, b) => {
    if (a.type !== b.type) return a.type === "folder" ? -1 : 1

    const sp = getStatusPriority(a) - getStatusPriority(b)
    
    if (sp !== 0) return sp;

    return a.title.localeCompare(b.title)
  })
  return sorted.map((n) => ({
    ...n,
    children: n.children ? sortTreeNodes(n.children) : undefined,
  }))
}

export const sortSearchResults = (nodes: TreeNode[]): TreeNode[] => {
  return sortTreeNodes(nodes)
}


